





































import Vue from 'vue';
import { inputDialog } from './Input';


export default Vue.extend({
  data: () => inputDialog,
  computed: {
    error(): boolean {
      return this.matches && !this.matches.test(this.value);
    },
  },
});
